<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :pageSize="5"
      tableCardTitle="Notes"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      :RightBtnOptions="{ text: 'Add', isHavePermission: true }"
      @changeTitleActionBtn="
        $router.push(`/customer-management/${companyId}/info/addNotes`)
      "
    >
      <template v-slot:noteName="{ tableRow }">
        <a
          href="javascript:void(0)"
          @click="handleHrefInfoPage(tableRow.row)"
          v-if="tableRow.row.isAuto === 1"
        >
          {{ tableRow.row.noteName }}
        </a>
        <p v-else>
          {{ tableRow.row.noteName }}
        </p>
      </template>
      <template v-slot:noteType="{ tableRow }">
        {{ filterNotes(tableRow.row.noteType) }}
      </template>
      <template v-slot:createTime="{ tableRow }">
        {{ tableRow.row.updateTime || tableRow.row.createTime }}
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-view1"
          style="margin-right: 20px; color: #3a3f63"
          @click="
            $router.push(
              `/customer-management/${companyId}/${tableRow.row.id}/info/editNotes`,
            )
          "
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void (0);"
            class="icon-trash1"
            slot="reference"
            style="color: #3a3f63"
          />
        </el-popconfirm>
      </template>
      <template v-slot:files="{ tableRow }">
        <el-popover
          placement="top"
          trigger="click"
          v-if="tableRow.row.files && tableRow.row.files.length"
        >
          <div
            style="text-align: center"
            v-for="item in tableRow.row.files"
            :key="item.id"
          >
            <a href="javascript:void (0)" @click="handleDownload(item.id)">
              {{ item.name }}
            </a>
          </div>
          <el-button type="text" slot="reference">Check</el-button>
        </el-popover>
      </template>
    </table-view>
    <el-dialog
      title="Edit"
      :visible.sync="showEdit"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        label-position="top"
        :rules="editRules"
      >
        <el-form-item label="Note Type:" prop="noteType">
          <el-select
            v-model="editForm.noteType"
            placeholder="Note Type"
            style="width: 100%"
          >
            <el-option
              v-for="item in noteTypeList"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Note Name:" prop="noteName">
          <el-input v-model="editForm.noteName"></el-input>
        </el-form-item>
        <el-form-item label="Comments:" prop="remark">
          <el-input v-model="editForm.remark"></el-input>
        </el-form-item>
        <el-form-item label="Attachments:">
          <multi-file-upload :file-list="fileList" ref="uploadComponent" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <customize-button @click="handleCancel">Cancel</customize-button>
        <customize-button
          type="primary"
          @click="handleSave"
          style="margin-left: 20px"
          :loading="isLoading"
        >
          Save
        </customize-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getTableData, noteTypeList, remove, download } from './api'
import { commonUpload } from '@/api'
import { getCssDetail } from 'views/credit-management/credit-all-history/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Note Name',
        type: 'input',
        key: 'noteName',
      },
      {
        label: 'Last Modify Time',
        type: 'time',
        key: 'time',
      },
      {
        label: 'Note Type',
        type: 'select',
        key: 'noteType',
        selectList: [],
      },
    ]
    const tableModel = [
      {
        label: 'Note Type',
        prop: 'noteTypeStr',
      },
      {
        label: 'Note Name',
        slotName: 'noteName',
      },
      {
        label: 'Last Modify Time',
        slotName: 'createTime',
      },
      {
        label: 'Modified by',
        prop: 'username',
      },
      {
        label: 'Attachments',
        slotName: 'files',
      },
      {
        width: 120,
        label: 'Action',
        slotName: 'action',
        fixed: 'left',
      },
    ]
    return {
      noteTypeList: noteTypeList,
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      form: { reducedAmount: '', reducedRemark: '', reducedDate: '' },
      visible: false,
      isTableLoading: true,
      companyId: this.$route.params.customerId,
      showEdit: false,
      isLoading: false,
      editForm: {
        id: '',
        noteType: '',
        remark: '',
        companyId: this.$route.params.customerId,
        noteName: '',
      },
      fileList: [],
      editRules: {
        noteType: [
          {
            required: true,
            message: 'must can not be empty!',
            trigger: 'change',
          },
        ],
        noteName: [
          {
            required: true,
            message: 'must can not be empty!',
            trigger: 'blur',
          },
        ],
      },
      bpmId: '',
    }
  },
  mounted() {
    this.searchModel[2].selectList = this.noteTypeList
    this.initTable()
  },
  methods: {
    // goto audit
    async handleHrefInfoPage(tableRow) {
      const regex = /\d+/
      const match = tableRow.noteName.match(regex)
      if (match) {
        this.bpmId = match[0]
      }
      this.$storage.setItem('bpmId', this.bpmId)

      const customerCode = this.$storage.getItem('customerInfo').code
      const cssSource = this.$store.state.source === 2

      if (cssSource) {
        const params = { bpmId: this.bpmId || this.$storage.getItem('bpmId') }
        const { running, creditInfo, additionalConditionsVOList, process } =
          await getCssDetail(params)

        switch (true) {
          case creditInfo.status === 6:
            return this.openNewTab(
              '/credit-management/css-audit/css-second-audit',
              this.bpmId,
              customerCode,
            )
          case (creditInfo.status === 1 &&
            additionalConditionsVOList.length === 0 &&
            process.length === 2) ||
            (creditInfo.decisionType === 1 &&
              additionalConditionsVOList.length !== 0 &&
              running === 1) ||
            (creditInfo.decisionType === 4 &&
              creditInfo.status === 1 &&
              additionalConditionsVOList.length !== 0 &&
              running === 1) ||
            running === 1:
            return this.openNewTab(
              '/credit-management/css-audit/single-audit',
              this.bpmId,
              customerCode,
            )
          default:
            return this.openNewTab(
              '/credit-management/css-audit/css-final-audit',
              this.bpmId,
              customerCode,
            )
        }
      }

      return this.openNewTab(
        '/credit-management/credit-audit/single-audit',
        this.bpmId,
        customerCode,
      )
    },

    openNewTab(path, bpmId, companyCode) {
      const routeUrl = this.$router.resolve({
        path: `${path}?bpmId=${bpmId}&companyCode=${companyCode}`,
      })
      window.open(routeUrl.href, '_blank')
    },
    async handleDownload(id) {
      try {
        await download(id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    filterNotes(noteType) {
      const res = this.noteTypeList.filter(item => item.id === noteType)
      if (res.length) {
        return res[0].name
      } else {
        return ''
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData({ ...params, companyId: this.companyId })
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData({ ...params, companyId: this.companyId })
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        // params.indateStart = params.startTime
        // params.indateEnd = params.endTime
        // delete params.endTime
        // delete params.startTime
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handlePageChange(params) {
      this._getTableData({ ...params, companyId: this.companyId })
    },
    async handleRemoveItem(id) {
      try {
        await remove(id)
        this.initTable()
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpload() {
      const fileList = this.$refs.uploadComponent.getCFileList()
      const resetFileList = fileList.filter(file => !file.id)
      const formData = new FormData()
      resetFileList.forEach(item => {
        formData.append('file', item.raw)
      })
      Object.keys(this.editForm).forEach(key => {
        formData.append(key, this.editForm[key])
      })
      this.isLoading = true
      return await commonUpload(formData)
    },
    async handleSave() {
      const valid = await this.$refs.editForm.validate()
      if (valid) {
        const id = await this.handleUpload()
        if (id) {
          this.$message.success('success')
          this.isLoading = false
          this.showEdit = false
          this.handleSearchChange()
        }
      }
    },
    handleCancel() {
      this.showEdit = false
      this.$refs.editForm.resetFields()
      this.fileList = []
    },
    handleEdit(data) {
      this.showEdit = true
      this.editForm = {
        ...this.editForm,
        id: data.id,
        noteType: data.noteType,
        remark: data.remark,
        noteName: data.noteName,
      }
      this.fileList = [...data.files]
      this.initTable()
    },
  },
}
</script>

<style lang="scss" scoped>
.content-wrapper {
  width: 872px;
  display: flex;
  justify-content: space-between;
  .el-form-item {
    flex: 1;
  }
}
.fileName {
  width: 300px;
  display: inline-block;
  margin-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
.dialog {
  :deep(.card) {
    padding: 0;
  }
}
</style>
